import { FounderQuote } from "@/components/FounderQuote";

export const ItStakeholderFounderQuote = () => {
  return (
    <FounderQuote
      quote="I've seen million-dollar projects stall because nobody knew who had final sign-off. Define your RACI matrix before writing a single line of code. The CTO sets the technical vision, the CIO aligns it with business strategy, and the IT Director makes it happen. When these roles blur, projects fail."
      author="ahsan"
      tagline="Building high-performance IT teams for 10+ years"
    />
  );
};
